import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Heart, Home, Plus, Search, User } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";
import { useMe } from "@/context/AuthContext";

const isField = (el) => el && (["INPUT", "TEXTAREA", "SELECT"].includes(el.tagName) || el.isContentEditable);

function useKeyboardOpen() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onIn = (e) => { if (isField(e.target) && !["checkbox", "radio", "file"].includes(e.target.type)) setOpen(true); };
    const onOut = () => setTimeout(() => setOpen(isField(document.activeElement)), 50);
    document.addEventListener("focusin", onIn);
    document.addEventListener("focusout", onOut);
    return () => { document.removeEventListener("focusin", onIn); document.removeEventListener("focusout", onOut); };
  }, []);
  return open;
}

export default function MobileBottomNav() {
  const { t } = useI18n();
  const { me } = useMe();
  const { pathname, search } = useLocation();
  const keyboard = useKeyboardOpen();
  const tab = new URLSearchParams(search).get("tab");
  const items = [
    ["home", "/", Home, pathname === "/"],
    ["search", "/search", Search, pathname === "/search"],
    ["add", "/add-property", Plus, pathname === "/add-property"],
    ["favorites", "/dashboard?tab=favorites", Heart, pathname === "/dashboard" && tab === "favorites"],
    ["account", me ? "/dashboard" : "/sign-in", User, (pathname === "/dashboard" && tab !== "favorites") || pathname === "/onboarding"],
  ];
  if (keyboard) return null;
  return (
    <nav className="bottom-nav header-bg md:hidden fixed bottom-0 inset-x-0 z-[1100] border-t border-line shadow-[0_-4px_16px_rgba(11,24,39,0.08)]" data-testid="mobile-bottom-nav">
      <ul className="grid grid-cols-5 h-[64px] items-end">
        {items.map(([k, to, Icon, active]) => (
          <li key={k} className="flex justify-center">
            {k === "add" ? (
              <Link to={to} data-testid="bottom-nav-add" aria-current={active ? "page" : undefined} className="-mt-6 flex flex-col items-center gap-1">
                <span className="grid place-items-center w-14 h-14 rounded-full bg-gold text-white shadow-lg shadow-gold/40 ring-4 ring-white dark:ring-navy"><Plus className="w-7 h-7" /></span>
                <span className="text-[11px] font-bold text-gold pb-1.5">{t("mnav.add")}</span>
              </Link>
            ) : (
              <Link to={to} data-testid={`bottom-nav-${k}`} aria-current={active ? "page" : undefined}
                className={`flex flex-col items-center gap-1 pb-2 text-[11px] font-semibold ${active ? "text-gold" : "text-ink-muted"}`}>
                <Icon className={`w-5 h-5 ${active ? "fill-gold/20" : ""}`} />{t(`mnav.${k}`)}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
}
